<template>
  <div>
    <FuncionalidadeCustomizadaChatBotComponent v-if="isChatBot"/>
    <FuncionalidadeCustomizadaWebViewComponent v-else-if="isWebView"/>
    <FuncionalidadeCustomizadaSolicitacaoComponent v-else-if="isSolicitacao"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import FuncionalidadeCustomizadaChatBotComponent
from '@/components/FuncionalidadeCustomizada/FuncionalidadeCustomizadaChatBotComponent.vue'
import FuncionalidadeCustomizadaWebViewComponent
from '@/components/FuncionalidadeCustomizada/FuncionalidadeCustomizadaWebViewComponent.vue'
import FuncionalidadeCustomizadaSolicitacaoComponent
from '@/components/FuncionalidadeCustomizada/FuncionalidadeCustomizadaSolicitacaoComponent.vue'

export default {
  name: 'FuncionalidadeCustomizadaComponent',
  data () {
    return {
      loaded: false
    }
  },
  components: {
    FuncionalidadeCustomizadaSolicitacaoComponent,
    FuncionalidadeCustomizadaWebViewComponent,
    FuncionalidadeCustomizadaChatBotComponent
  },
  computed: {
    ...mapGetters('SetupApp', ['funcParams']),
    isChatBot () {
      return this.funcParams.fluxo
    },
    isWebView () {
      return this.funcParams.AberturaWebviewWeb
    },
    isSolicitacao () {
      return this.funcParams.idTemplateSolicitacao
    }
  }
}
</script>
